export default "__VITE_ASSET__DDrBbEqt__"